import { db } from '@/plugins/firebase'
import { getDocs, collection, query, orderBy, limit, where, deleteDoc, doc } from 'firebase/firestore'
import { ActionContext } from 'vuex';
import moment from 'moment';
import { RootState } from '@/store/index';
import { Suggestion, SuggestionsState } from '@/models/models'

const state = {
  suggestions: [],
};

const mutations = {
  setSuggestions(state: SuggestionsState, suggestions: Suggestion[]) {
    state.suggestions = suggestions;
  },
  removeSuggestion(state: SuggestionsState, suggestionId: string) {
    state.suggestions = state.suggestions.filter(s => s.id !== suggestionId);
  }
};

const actions = {
  async fetchSuggestions({ commit }: ActionContext<SuggestionsState, RootState>, uid: string) {
    const suggestionsRef = collection(db, `users/${uid}/suggestions`);
    const q = query(suggestionsRef, orderBy('created_at', 'desc'), limit(1));
    const querySnapshot = await getDocs(q);

    const suggestions: Suggestion[] = querySnapshot.docs.map(doc => ({
      id: doc.id,
      transcription_id: doc.data().transcription_id,
      created_at: moment(doc.data().created_at.toDate()).format('YYYY/MM/DD/H:mm:ss'),
      model: doc.data().model,
      suggestion_details: doc.data().suggestion_details,
    }));

    commit('setSuggestions', suggestions);
  },

  async fetchSuggestionsByDate({ commit }: ActionContext<SuggestionsState, RootState>, { uid, date }: { uid: string, date: string }) {
    const suggestionsRef = collection(db, `users/${uid}/suggestions`);
    const stardOfDay = moment(date, 'YYYY/MM/DD').startOf('day').toDate();
    const endOfDay = moment(date, 'YYYY/MM/DD').endOf('day').toDate();

    const q = query(suggestionsRef,
      where('lesson_date', '>=', stardOfDay),
      where('lesson_date', '<', endOfDay));
    const querySnapshot = await getDocs(q);

    const suggestions: Suggestion[] = querySnapshot.docs.map(doc => ({
      id: doc.id,
      transcription_id: doc.data().transcription_id,
      created_at: moment(doc.data().created_at.toDate()).format('YYYY/MM/DD/H:mm:ss'),
      model: doc.data().model,
      suggestion_details: doc.data().suggestion_details,
    }));

    commit('setSuggestions', suggestions);
  },

  async deleteSuggestion({ commit }: ActionContext<SuggestionsState, RootState>, { uid, suggestionId }: { uid: string, suggestionId: string }) {
    try {
      const suggestionsRef = doc(db, `users/${uid}/suggestions/${suggestionId}`);
      await deleteDoc(suggestionsRef);
      commit('removeSuggestion', suggestionId);
    } catch (error) {
      console.error('Error deleting suggestion', error)
    }
  },
};

const getters = {
  suggestions: (state: SuggestionsState): Suggestion[] => state.suggestions,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
